<template>
    <div class="promotion-panel leader-panel">
        <div class="panel-heading">
            <div>
                <h2>楼长任职与统计</h2>
                <p>只能从已启用的普通用户中任命；调岗会生成新的推广码，旧推广码不会恢复。</p>
            </div>
            <el-button type="warning" icon="el-icon-plus" @click="appointmentDialogVisible = true">
                任命楼长
            </el-button>
        </div>

        <div class="filter-card">
            <el-form :inline="true" size="small" @submit.native.prevent="loadAppointments">
                <el-form-item label="任职状态">
                    <el-select v-model="filters.status" clearable placeholder="全部" @change="loadAppointments">
                        <el-option label="启用" value="1" />
                        <el-option label="已结束" value="0" />
                    </el-select>
                </el-form-item>
                <el-form-item label="学校">
                    <el-select v-model="filters.schoolId" clearable placeholder="全部" @change="handleSchoolChange">
                        <el-option
                            v-for="school in schools"
                            :key="school.schoolId || school.id"
                            :label="school.name"
                            :value="school.schoolId || school.id" />
                    </el-select>
                </el-form-item>
                <el-form-item label="宿舍楼">
                    <el-select v-model="filters.buildingId" clearable placeholder="全部">
                        <el-option
                            v-for="building in buildings"
                            :key="building.buildingId || building.id"
                            :label="building.name"
                            :value="building.buildingId || building.id" />
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="loadAppointments">查询</el-button>
                    <el-button icon="el-icon-refresh" @click="resetFilters">重置</el-button>
                </el-form-item>
            </el-form>
        </div>

        <div class="summary-grid">
            <div class="summary-card">
                <span>有效邀请关系</span>
                <strong>{{ summaryTotal }}</strong>
            </div>
            <div class="summary-card" v-for="item in summaries" :key="summaryKey(item)">
                <span>{{ item.leaderName || item.leaderUserName || '楼长' }}</span>
                <strong>{{ item.validInvitationCount || item.invitationCount || 0 }}</strong>
                <small>{{ item.schoolName || '' }} {{ item.buildingName || '' }}</small>
            </div>
        </div>

        <el-table v-loading="loading" :data="appointments" stripe empty-text="暂无任职记录">
            <el-table-column label="楼长" min-width="150">
                <template slot-scope="scope">
                    <div>{{ scope.row.leaderName || scope.row.leaderUserName || scope.row.leaderUserId || '-' }}</div>
                    <small class="muted">用户 ID：{{ scope.row.leaderUserId || '-' }}</small>
                </template>
            </el-table-column>
            <el-table-column prop="schoolName" label="学校" min-width="130" />
            <el-table-column prop="buildingName" label="宿舍楼" min-width="120" />
            <el-table-column label="状态" width="85">
                <template slot-scope="scope">
                    <el-tag :type="isActive(scope.row) ? 'success' : 'info'" size="mini">
                        {{ isActive(scope.row) ? '启用' : '已结束' }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="推广码" min-width="130">
                <template slot-scope="scope">{{ scope.row.promotionCode || '-' }}</template>
            </el-table-column>
            <el-table-column label="任职时间" min-width="170">
                <template slot-scope="scope">
                    {{ scope.row.startedAt || scope.row.startTime || '-' }}
                    <span v-if="scope.row.endedAt || scope.row.endTime">至 {{ scope.row.endedAt || scope.row.endTime }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="260" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" @click="openOfficialPoster(scope.row)">官方海报</el-button>
                    <el-button v-if="isActive(scope.row)" type="text" @click="openTransfer(scope.row)">调岗</el-button>
                    <el-button v-if="isActive(scope.row)" type="text" class="danger-text" @click="openEnd(scope.row)">结束任职</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog title="任命楼长" :visible.sync="appointmentDialogVisible" width="500px" @closed="resetAppointmentForm">
            <el-alert
                title="这里只提交已有启用普通用户的 userId，不会创建新用户。"
                type="info"
                :closable="false"
                show-icon
                class="dialog-alert" />
            <el-form ref="appointmentForm" :model="appointmentForm" :rules="appointmentRules" label-width="115px">
                <el-form-item label="普通用户 ID" prop="leaderUserId">
                    <el-input v-model.trim="appointmentForm.leaderUserId" placeholder="请输入已有启用普通用户 ID" />
                </el-form-item>
                <el-form-item label="学校" prop="schoolId">
                    <el-select v-model="appointmentForm.schoolId" style="width: 100%" placeholder="请选择启用学校" @change="loadAppointmentBuildings">
                        <el-option
                            v-for="school in schools"
                            :key="school.schoolId || school.id"
                            :label="school.name"
                            :value="school.schoolId || school.id" />
                    </el-select>
                </el-form-item>
                <el-form-item label="宿舍楼" prop="buildingId">
                    <el-select v-model="appointmentForm.buildingId" style="width: 100%" placeholder="请选择启用宿舍楼">
                        <el-option
                            v-for="building in appointmentBuildings"
                            :key="building.buildingId || building.id"
                            :label="building.name"
                            :value="building.buildingId || building.id" />
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="appointmentDialogVisible = false">取消</el-button>
                <el-button type="warning" :loading="saving" @click="createAppointment">任命</el-button>
            </span>
        </el-dialog>

        <el-dialog title="调岗楼长" :visible.sync="transferDialogVisible" width="500px" @closed="resetTransferForm">
            <el-form ref="transferForm" :model="transferForm" :rules="transferRules" label-width="115px">
                <el-form-item label="新楼长用户 ID" prop="leaderUserId">
                    <el-input v-model.trim="transferForm.leaderUserId" placeholder="请输入已有启用普通用户 ID" />
                </el-form-item>
                <el-form-item label="新学校" prop="schoolId">
                    <el-select v-model="transferForm.schoolId" style="width: 100%" placeholder="请选择启用学校" @change="loadTransferBuildings">
                        <el-option
                            v-for="school in schools"
                            :key="school.schoolId || school.id"
                            :label="school.name"
                            :value="school.schoolId || school.id" />
                    </el-select>
                </el-form-item>
                <el-form-item label="新宿舍楼" prop="buildingId">
                    <el-select v-model="transferForm.buildingId" style="width: 100%" placeholder="请选择启用宿舍楼">
                        <el-option
                            v-for="building in transferBuildings"
                            :key="building.buildingId || building.id"
                            :label="building.name"
                            :value="building.buildingId || building.id" />
                    </el-select>
                </el-form-item>
                <el-form-item label="调岗原因" prop="reason">
                    <el-input v-model.trim="transferForm.reason" type="textarea" :rows="3" maxlength="200" show-word-limit />
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="transferDialogVisible = false">取消</el-button>
                <el-button type="warning" :loading="saving" @click="transferAppointment">确认调岗</el-button>
            </span>
        </el-dialog>

        <el-dialog title="结束任职" :visible.sync="endDialogVisible" width="460px">
            <el-form ref="endForm" :model="endForm" :rules="endRules" label-width="90px">
                <el-form-item label="结束原因" prop="reason">
                    <el-input v-model.trim="endForm.reason" type="textarea" :rows="4" maxlength="200" show-word-limit />
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="endDialogVisible = false">取消</el-button>
                <el-button type="danger" :loading="saving" @click="endAppointment">结束任职</el-button>
            </span>
        </el-dialog>

        <el-dialog title="楼长官方海报" :visible.sync="posterDialogVisible" width="520px">
            <div v-loading="posterLoading" class="official-poster">
                <img v-if="posterImage" :src="posterImage" alt="楼长官方海报">
                <el-empty v-else description="暂无海报数据" />
            </div>
        </el-dialog>
    </div>
</template>

<script>
import request from "@/tool/request";
import API from "@/tool/api";
import {
    asList,
    getResultData,
    getResultMessage,
    isResultSuccess,
} from "@/tool/result";

const jsonConfig = { headers: { "Content-Type": "application/json" } };

export default {
    data() {
        const required = (message) => ({ required: true, message, trigger: "blur" });
        return {
            schools: [],
            buildings: [],
            appointmentBuildings: [],
            transferBuildings: [],
            appointments: [],
            summaries: [],
            loading: false,
            saving: false,
            posterLoading: false,
            posterImage: "",
            posterDialogVisible: false,
            appointmentDialogVisible: false,
            transferDialogVisible: false,
            endDialogVisible: false,
            filters: { status: "", schoolId: "", buildingId: "" },
            appointmentForm: { leaderUserId: "", schoolId: "", buildingId: "" },
            transferForm: { appointmentId: "", leaderUserId: "", schoolId: "", buildingId: "", reason: "" },
            endForm: { appointmentId: "", reason: "" },
            appointmentRules: {
                leaderUserId: [required("请输入已有普通用户 ID")],
                schoolId: [{ required: true, message: "请选择学校", trigger: "change" }],
                buildingId: [{ required: true, message: "请选择宿舍楼", trigger: "change" }],
            },
            transferRules: {
                leaderUserId: [required("请输入已有普通用户 ID")],
                schoolId: [{ required: true, message: "请选择学校", trigger: "change" }],
                buildingId: [{ required: true, message: "请选择宿舍楼", trigger: "change" }],
                reason: [required("请输入调岗原因")],
            },
            endRules: { reason: [required("请输入结束原因")] },
        };
    },
    computed: {
        summaryTotal() {
            return this.summaries.reduce((total, item) => total + Number(item.validInvitationCount || item.invitationCount || 0), 0);
        },
    },
    mounted() {
        this.loadSchools();
        this.loadAppointments();
        this.loadSummaries();
    },
    methods: {
        idOf(item, key) {
            return item && (item[key] || item.id);
        },
        isActive(item) {
            return item && (item.status === 1 || item.status === "1" || item.active === true);
        },
        loadSchools() {
            request.get(API.promotion.schools.list, { params: { status: 1 } })
                .then((response) => {
                    if (isResultSuccess(response)) this.schools = asList(response);
                    else this.$message.error(getResultMessage(response, "学校列表加载失败"));
                })
                .catch((error) => this.$message.error(getResultMessage(error, "学校列表加载失败")));
        },
        loadBuildings(schoolId, target = "buildings") {
            if (!schoolId) {
                this[target] = [];
                return;
            }
            request.get(API.promotion.buildings.list, { params: { schoolId, status: 1 } })
                .then((response) => {
                    if (isResultSuccess(response)) this[target] = asList(response);
                    else this.$message.error(getResultMessage(response, "宿舍楼列表加载失败"));
                })
                .catch((error) => this.$message.error(getResultMessage(error, "宿舍楼列表加载失败")));
        },
        handleSchoolChange() {
            this.filters.buildingId = "";
            this.loadBuildings(this.filters.schoolId);
            this.loadAppointments();
            this.loadSummaries();
        },
        loadAppointmentBuildings() {
            this.appointmentForm.buildingId = "";
            this.loadBuildings(this.appointmentForm.schoolId, "appointmentBuildings");
        },
        loadTransferBuildings() {
            this.transferForm.buildingId = "";
            this.loadBuildings(this.transferForm.schoolId, "transferBuildings");
        },
        loadAppointments() {
            this.loading = true;
            const payload = {};
            Object.keys(this.filters).forEach((key) => {
                if (this.filters[key] !== "" && this.filters[key] !== null && this.filters[key] !== undefined) payload[key] = this.filters[key];
            });
            request.post(API.promotion.appointments.search, payload, jsonConfig)
                .then((response) => {
                    if (!isResultSuccess(response)) {
                        this.$message.error(getResultMessage(response, "任职列表加载失败"));
                        return;
                    }
                    this.appointments = asList(response);
                })
                .catch((error) => this.$message.error(getResultMessage(error, "任职列表加载失败")))
                .finally(() => {
                    this.loading = false;
                });
        },
        loadSummaries() {
            const params = {};
            if (this.filters.schoolId) params.schoolId = this.filters.schoolId;
            if (this.filters.buildingId) params.buildingId = this.filters.buildingId;
            request.get(API.promotion.summaries, { params })
                .then((response) => {
                    if (isResultSuccess(response)) this.summaries = asList(response);
                    else this.$message.error(getResultMessage(response, "推广统计加载失败"));
                })
                .catch((error) => this.$message.error(getResultMessage(error, "推广统计加载失败")));
        },
        resetFilters() {
            this.filters = { status: "", schoolId: "", buildingId: "" };
            this.buildings = [];
            this.loadAppointments();
            this.loadSummaries();
        },
        resetAppointmentForm() {
            this.appointmentForm = { leaderUserId: "", schoolId: "", buildingId: "" };
            this.appointmentBuildings = [];
            if (this.$refs.appointmentForm) this.$refs.appointmentForm.clearValidate();
        },
        createAppointment() {
            this.$refs.appointmentForm.validate((valid) => {
                if (!valid) return;
                this.saving = true;
                request.post(API.promotion.appointments.create, this.appointmentForm, jsonConfig)
                    .then((response) => {
                        if (!isResultSuccess(response)) {
                            this.$message.error(getResultMessage(response, "任命失败"));
                            return;
                        }
                        this.$message.success("楼长任命成功");
                        this.appointmentDialogVisible = false;
                        this.loadAppointments();
                        this.loadSummaries();
                    })
                    .catch((error) => this.$message.error(getResultMessage(error, "任命失败")))
                    .finally(() => {
                        this.saving = false;
                    });
            });
        },
        openTransfer(appointment) {
            this.transferForm = {
                appointmentId: this.idOf(appointment, "appointmentId"),
                leaderUserId: "",
                schoolId: "",
                buildingId: "",
                reason: "",
            };
            this.transferDialogVisible = true;
        },
        resetTransferForm() {
            this.transferForm = { appointmentId: "", leaderUserId: "", schoolId: "", buildingId: "", reason: "" };
            this.transferBuildings = [];
            if (this.$refs.transferForm) this.$refs.transferForm.clearValidate();
        },
        transferAppointment() {
            this.$refs.transferForm.validate((valid) => {
                if (!valid) return;
                const appointmentId = this.transferForm.appointmentId;
                const payload = {
                    leaderUserId: this.transferForm.leaderUserId,
                    schoolId: this.transferForm.schoolId,
                    buildingId: this.transferForm.buildingId,
                    reason: this.transferForm.reason,
                };
                this.saving = true;
                request.post(API.promotion.appointments.transfer(appointmentId), payload, jsonConfig)
                    .then((response) => {
                        if (!isResultSuccess(response)) {
                            this.$message.error(getResultMessage(response, "调岗失败"));
                            return;
                        }
                        this.$message.success("调岗成功，旧推广码已失效");
                        this.transferDialogVisible = false;
                        this.loadAppointments();
                        this.loadSummaries();
                    })
                    .catch((error) => this.$message.error(getResultMessage(error, "调岗失败")))
                    .finally(() => {
                        this.saving = false;
                    });
            });
        },
        openEnd(appointment) {
            this.endForm = { appointmentId: this.idOf(appointment, "appointmentId"), reason: "" };
            this.endDialogVisible = true;
        },
        endAppointment() {
            this.$refs.endForm.validate((valid) => {
                if (!valid) return;
                this.saving = true;
                request.put(API.promotion.appointments.end(this.endForm.appointmentId), null, {
                    params: { reason: this.endForm.reason },
                })
                    .then((response) => {
                        if (!isResultSuccess(response)) {
                            this.$message.error(getResultMessage(response, "结束任职失败"));
                            return;
                        }
                        this.$message.success("任职已结束，推广码已失效");
                        this.endDialogVisible = false;
                        this.loadAppointments();
                        this.loadSummaries();
                    })
                    .catch((error) => this.$message.error(getResultMessage(error, "结束任职失败")))
                    .finally(() => {
                        this.saving = false;
                    });
            });
        },
        summaryKey(item) {
            return item.leaderUserId || item.appointmentId || `${item.schoolId}-${item.buildingId}`;
        },
        openOfficialPoster(appointment) {
            const appointmentId = this.idOf(appointment, "appointmentId");
            this.posterImage = "";
            this.posterDialogVisible = true;
            this.posterLoading = true;
            request.get(API.promotion.appointments.poster(appointmentId))
                .then((response) => {
                    if (!isResultSuccess(response)) {
                        this.$message.error(getResultMessage(response, "官方海报加载失败"));
                        return;
                    }
                    const data = getResultData(response) || {};
                    this.posterImage = data.imageData || "";
                })
                .catch((error) => this.$message.error(getResultMessage(error, "官方海报加载失败")))
                .finally(() => {
                    this.posterLoading = false;
                });
        },
    },
};
</script>

<style scoped>
.panel-heading {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 18px;
    margin-bottom: 20px;
}

.panel-heading h2 {
    margin: 0;
    font-size: 22px;
}

.panel-heading p {
    margin: 8px 0 0;
    color: #909399;
}

.filter-card {
    padding: 18px 20px 4px;
    margin-bottom: 20px;
    background: #f8f9fc;
    border: 1px solid #ebeef5;
    border-radius: 8px;
}

.filter-card >>> .el-form-item {
    margin-bottom: 14px;
}

.summary-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 20px;
}

.summary-card {
    min-width: 150px;
    padding: 15px 18px;
    background: #fffaf1;
    border: 1px solid #f5dab0;
    border-radius: 8px;
}

.summary-card span,
.summary-card small {
    display: block;
    color: #909399;
}

.summary-card strong {
    display: block;
    margin: 6px 0;
    color: #e6a23c;
    font-size: 25px;
}

.muted {
    color: #909399;
}

.danger-text {
    color: #f56c6c;
}

.dialog-alert {
    margin-bottom: 20px;
}

.official-poster {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 280px;
}

.official-poster img {
    max-width: 100%;
    max-height: 650px;
    object-fit: contain;
}

@media (max-width: 700px) {
    .panel-heading {
        display: block;
    }

    .panel-heading .el-button {
        margin-top: 16px;
    }
}
</style>
